import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'cityads-v3/types/reducer';
import { LanguageCode } from 'cityads-v3/types/auth';

import { DEFAULT_LANGUAGE } from 'cityads-v3/i18n/utils';

export const USERDOCS_HOST = 'https://userdocs.cityads.com';

const USERDOCS_ROOT = '/docs/udocs';

const USERDOCS_LANGUAGE_CODES = ['en', 'ru', 'vi'] as const;
type UserdocsLanguageCode = typeof USERDOCS_LANGUAGE_CODES[number];

function isUserdocsLanguageCode(maybeCode: unknown): maybeCode is UserdocsLanguageCode {
  return typeof maybeCode === 'string' && USERDOCS_LANGUAGE_CODES.includes(maybeCode as UserdocsLanguageCode);
}

function getUserdocsLanguage(language: LanguageCode): UserdocsLanguageCode {
  return isUserdocsLanguageCode(language) ? language : DEFAULT_LANGUAGE as UserdocsLanguageCode;
}

type UserdocsLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & React.PropsWithChildren<{
  href: string,
  languages?: UserdocsLanguageCode[],
  forceLanguage?: UserdocsLanguageCode,
}>;

const UserdocsLink = forwardRef<HTMLAnchorElement, UserdocsLinkProps>(
  function UserdocsLink({ href, children, languages, forceLanguage, ...rest }: UserdocsLinkProps, ref): JSX.Element {
    const language = useSelector<RootState, LanguageCode>(state => state.language.language);

    let userdocsLanguage = getUserdocsLanguage(language);

    if (languages && !languages.includes(userdocsLanguage)) {
      userdocsLanguage = DEFAULT_LANGUAGE as UserdocsLanguageCode;

      if (!languages.includes(userdocsLanguage)) {
        return null;
      }
    }

    return (
      <a href={`${USERDOCS_HOST}${USERDOCS_ROOT}/${forceLanguage ?? userdocsLanguage}/latest${href || ''}`} target="_blank" rel="noreferrer noopener" {...rest} ref={ref}>{children}</a>
    );
  }
);

export default UserdocsLink;
